module.exports = __webpack_public_path__ + "static/media/validate-image.68ec9a2f.svg";